import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { Form, Button } from 'formik-semantic-ui';
import { IPtw } from '@relab/alstom-ptw-shared';
import moment, { Moment } from 'moment';

import { ptwEditAction } from '../../redux/actions';
import { DatePicker } from '../DatePicker';
import { TimePickerComponent } from '../TimePickerComponent';
import { TranslationComponent } from '../TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

interface PtwDateEditModalProps {
  i18n: typeof i18n;
  t: typeof i18n.t;
  projectId: string;
  ptw: IPtw;
  ptwEditAction: typeof ptwEditAction;
}

class PPtwDateEditModal extends Component<PtwDateEditModalProps> {
  state: { open: boolean } = {
    open: false,
  };

  toggleOpen = (open: boolean) => {
    this.setState({ open });
  };

  handleSubmit = ({ endDate, endTime }: { endDate: any; endTime: Moment }) => {
    const { ptw, ptwEditAction } = this.props;

    const momentEndDate = moment(endDate);
    const endTimestamp = moment({
      year: momentEndDate.year(),
      month: momentEndDate.month(),
      day: momentEndDate.date(),
      hour: endTime.hour(),
      minute: endTime.minute(),
      second: 0,
      millisecond: 0,
    });

    ptwEditAction({ ...ptw, endTimestamp });
    this.toggleOpen(false);
  };

  render() {
    const { ptw, t } = this.props;
    return (
      <Modal
        open={this.state.open}
        onClose={() => this.toggleOpen(false)}
        trigger={<Button icon="pencil alternate" onClick={() => this.toggleOpen(true)} />}
      >
        <Modal.Header>
          <TranslationComponent stringKey={'Edit end date'} />
        </Modal.Header>
        <Modal.Content>
          <Form
            initialValues={{ endDate: ptw.endTimestamp, endTime: moment(ptw.endTimestamp) }}
            onSubmit={this.handleSubmit}
            render={({ values }) => (
              <React.Fragment>
                <DatePicker
                  label={t('End date')}
                  name="endDate"
                  inputProps={{
                    placeholder: '',
                    isOutsideRange: (day) => day.isBefore(moment(ptw.startTimestamp)),
                  }}
                />
                <TimePickerComponent
                  label={t('End time')}
                  name="endTime"
                  inputProps={{ showSecond: false, defaultValue: values.endTime }}
                />

                <Button onClick={() => this.toggleOpen(false)}>
                  <TranslationComponent stringKey={'Cancel'} />
                </Button>
                <Button.Submit>
                  <TranslationComponent stringKey={'Confirm'} />
                </Button.Submit>
              </React.Fragment>
            )}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

export const PtwDateEditModal = connect(null, { ptwEditAction })(withTranslation()(PPtwDateEditModal));
